module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAARCAYAAADKZhx3AAABGUlEQVRIS7XUvU7CUBQH8P9p0dXS0MHNhfgEzoaFwRcxcUF3nXQHBhUfBAYWwuwTEB6gA0bLitwec5u2qbUf95brHXs/fv0n5xxyXvnMDvEExmd4hIeva9riH1b7jU+sbzyC4AoL9+Q+85SAq9h6Fzv0gzsKTNrOkB37GHMAF/JdBmZ5WH43iufRFPYm3A0FlgBOMymN4EUoAN/a45Ik1nnhc2YsTOJlKBF6Hze0imDTeB0qvRQ2haugf+BDcVW0EG6K66ClsC6ui1bCqngTtBauw+V+diLFDeInLVM1/X5VddnBsj6Pz0djUAdVSlzT59l/VUqaXFBKrIBroVqJK3BttBEsL3lj7ooWRlFx7XG7GdC6qpCK9n4AnuvZWLcR1asAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/user/icon_9.png
// module id = TmQ2
// module chunks = 1